<template>
  <div class="centCommission">
    <van-sticky :offset-top="isiOSX ? 88 : 68">
      <div class="centCommission_title">
        <div class="title_top">
          <div
            v-for="(item, index) in tabOption"
            :key="index"
            @click="tanChange(item.value)"
          >
            <p>{{ item.title }}</p>
            <!-- <span v-if="is_online == item.value"></span> -->
          </div>
        </div>
        <div class="title_content">
          <div>
            <van-icon class="ques" name="question-o" @click="tipSheet = true" />
            <p>{{ dateTime }}结算总计：{{ total_amount }}</p>
          </div>
          <span @click="datetimePickerShow = true"
            >{{ dateTime }}
            <img src="./../../../assets/decoration/bottom.png" alt="" />
          </span>
        </div>
      </div>
    </van-sticky>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <template #finished>
        <div class="finishedTip">
          <div v-if="dataList.length == 0">
            <img src="./../../../assets/decoration/noData.png" alt="" />
            <p>暂无结算记录</p>
          </div>
          <div v-else>没有更多了</div>
        </div>
      </template>
      <div class="centCommission_content">
        <div
          class="card"
          v-for="(item, index) in dataList"
          :key="index"
          @click="toDetails(item.id)"
        >
          <div>
            <p>{{ item.order.member_name }}的订单结算</p>
            <span>{{ item.commission_at }}</span>
          </div>
          <span>+{{ item.amount }}</span>
        </div>
      </div>
    </van-list>

    <van-action-sheet v-model="datetimePickerShow">
      <div class="content">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          cancel-button-text="清除"
          @confirm="datetimeConfirm"
          @cancel="datetimeCancel"
        />
      </div>
    </van-action-sheet>

    <van-action-sheet v-model="tipSheet" :title="tipSheetTitle">
      <div class="tipSheet">
        结算列表里的订单是在线上进行结算，结算后的金额是可以进行提现的金额。
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  props: {
    city_agent_id: {
      default: null,
    },
    minDate: {
      required: true,
    },
    isiOSX: {
      default: false,
    },
    is_agent: {
      default: true,
    },
    area_id: {
      default: null,
    },
  },
  data() {
    return {
      datetimePickerShow: false,
      maxDate: new Date(),
      currentDate: new Date(),
      dateTime: "全部",
      total_amount: 0,
      year: null,
      month: null,
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      dataList: [],
      tipSheet: false,
      tabOption: [
        { title: "结算列表", value: 1 },
        // { title: "线下结算", value: -1 },
      ],
      is_online: 1,
      tipSheetTitle: "结算记录说明",
    };
  },
  created() {
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      if (this.is_agent) {
        //   代理人
        this.$api
          .post("decoration/member/city/agent/commiss/list", {
            city_agent_id: this.city_agent_id,
            pageSize: this.pageSize,
            page: this.page,
            year: this.year, //类型：Number  必有字段  备注：年份
            month: this.month, //类型：String  必有字段  备注：月份
            is_online: this.is_online,
          })
          .then((res) => {
            //   console.log(res);
            this.dataList = this.dataList.concat(res.list);
            this.total_amount = res.total_amount;
            this.loaded = true;
            this.refreshing = false;
            this.loading = false;
            if (this.dataList.length >= res.total) {
              // 数据全部加载完成
              this.finished = true;
            } else {
              this.finished = false;
            }
          })
          .catch((err) => {
            this.refreshing = false;
            this.loading = false;
            this.finished = true;
          });
      } else {
        //   合伙人
        this.$api
          .post("decoration/member/city/partner/order/commissions/list", {
            area_id: this.area_id,
            pageSize: this.pageSize,
            page: this.page,
            year: this.year, //类型：Number  必有字段  备注：年份
            month: this.month, //类型：String  必有字段  备注：月份
            is_online: this.is_online,
          })
          .then((res) => {
            //   console.log(res);
            this.dataList = this.dataList.concat(res.list);
            this.total_amount = res.total_amount;
            this.loaded = true;
            this.refreshing = false;
            this.loading = false;
            if (this.dataList.length >= res.total) {
              // 数据全部加载完成
              this.finished = true;
            } else {
              this.finished = false;
            }
          })
          .catch((err) => {
            this.refreshing = false;
            this.loading = false;
            this.finished = true;
          });
      }
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    datetimeConfirm(e) {
      this.year = e.getFullYear();
      this.month =
        e.getMonth() + 1 >= 10 ? e.getMonth() + 1 : `0${e.getMonth() + 1}`;
      this.dateTime = `${this.year}.${this.month}`;
      this.datetimePickerShow = false;
      this.onRefresh();
    },
    datetimeCancel(e) {
      this.datetimePickerShow = false;
      this.year = null;
      this.month = null;
      this.dateTime = "全部";
      this.onRefresh();
    },
    tanChange(value) {
      this.is_online = value;
      this.year = null;
      this.month = null;
      this.dateTime = "全部";
      // if (this.is_online == 1) {
      //   this.tipSheetTitle = "线上结算记录说明";
      // } else {
      //   this.tipSheetTitle = "线下结算记录说明";
      // }
      this.onRefresh();
    },
    toDetails(id) {
      this.$router.push({
        path: "/decoration/deputy/centCommissionDetails",
        query: {
          commission_id: id,
          is_agent: this.is_agent,
        },
      });
    },
  },
};
</script>
<style lang="less">
.centCommission {
  //   margin: 0 16px;
  .centCommission_title {
    padding: 4px 24px;
    .title_top {
      display: flex;
      div {
        margin-right: 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        p {
          font-size: 15px;
          color: #333333;
          line-height: 21px;
          font-weight: 700;
        }
        span {
          width: 24px;
          height: 4px;
          background: linear-gradient(90deg, #918bf6 0%, #5853e9 100%);
          border-radius: 3px;
          margin-top: 4px;
        }
      }
    }
    .title_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      .ques {
        color: #666666;
        transform: translateY(-1px);
      }
      div {
        display: flex;
        align-items: center;
        p {
          font-size: 13px;
          color: #666666;
          line-height: 18px;
          margin-left: 3px;
        }
      }
      span {
        background: #ffffff;
        border-radius: 12px;
        padding: 4px 8px;
        font-size: 13px;
        color: #666666;
        // line-height: 18px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 5px;
        }
      }
    }
  }
  .centCommission_content {
    margin: 0 16px;
    .card {
      margin-top: 12px;
      background-color: #ffffff;
      border-radius: 8px;
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        font-size: 13px;
        line-height: 18px;
        display: flex;
        flex-direction: column;
        p {
          color: #333333;
          font-weight: 600;
        }
        span {
          font-size: 13px;
          color: #999999;
          font-weight: 400;
          margin-top: 12px;
        }
      }
      span {
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        line-height: 22px;
      }
    }
  }
  .tipSheet {
    padding: 24px 24px 100px;
    font-size: 14px;
    color: #6e727a;
    line-height: 20px;
  }
  .finishedTip {
    img {
      width: 149px;
      height: 125px;
      margin-top: 32px;
    }
  }
}
.van-sticky--fixed .centCommission_title {
  background-color: #f5f6ff;
}
</style>